module.exports = __webpack_public_path__ + "static/media/spo.93ffbfbd.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/spo.png
// module id = 862
// module chunks = 6